<template>
  <div>
    <PageHeader
      :schema="$schemas.allType"
      :titleCustom="title"
      :descriptionCustom="description"
    />
    <PageContent>
      <DynamicFormPage
        :schema="$schemas.allType"
        :service="$api.allTypes"
        :fixed-payload="fixedPayload"
      />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';
import { kebabCase } from 'lodash';

export default {
  name: 'CreateAllTypes',
  components: { PageHeader, PageContent, DynamicFormPage },
  computed: {
    fixedPayload() {
      return { type: kebabCase(this.$route.meta.type) };
    },
    title() {
      return this.$route.meta.title;
    },
    description() {
      return this.$route.meta.description;
    },
  },
};
</script>
